var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "eu-flex eu-column eu-row_xl eu-align-items_center" },
        [
          _c(
            "div",
            { staticClass: "eu-flex-item" },
            [
              _c(
                "emd-button",
                {
                  attrs: { color: "secondary", type: "link" },
                  on: { click: _vm.togglePixModal },
                },
                [
                  _c("span", { staticClass: "uil uil-qrcode-scan" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("charge.detail.payment-method.pix.view-qr-code")
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "eu-flex-item" },
            [
              _c(
                "emd-button",
                {
                  staticClass: "eu-mr_1",
                  attrs: { color: "secondary", type: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.copyToClipboard(_vm.qrCodeUrl)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "uil uil-copy" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("charge.detail.payment-method.pix.copy-qr-code")
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "emd-badge eu-ml_2 _color_secondary",
                  class: { "eu-hidden": !_vm.copyQrCode },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("charge.detail.payment-method.pix.copy")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("PixModal", {
        attrs: {
          "charge-id": _vm.chargeId,
          "qr-code-url": _vm.qrCodeUrl,
          open: _vm.pixModalOpen,
        },
        on: { handleOpen: () => (_vm.pixModalOpen = _vm.$event) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }